import { gql } from '@apollo/client';

export const GET_CAMPAIGNS = gql`
    query (
        $offset: Int = 0
        $limit: Int = 10
        $orderBy: String = "name"
        $orderByDirection: GraphQLDirection = ASC
        $filter: MultiTypeInput = "%"
    ) {
        table(
            name: "campaign"
            columns: [
                "id"
                "name"
                "startdate"
                "enddate"
                "description"
                "isactive"
                "islocal"
                "sfid"
            ]
            filter: [
                { left: "isdeleted", right: "false", expression: "=" }
                {
                    or_: [
                        { left: "name", right: $filter, expression: "iLIKE" }
                        { left: "description", right: $filter, expression: "iLIKE" }
                    ]
                }
            ]
            offset: $offset
            limit: $limit
            orderBy: $orderBy
            orderByDirection: $orderByDirection
        )
    }
`;

export const GET_CAMPAIGNS_FOR_PROPERTY_WITH_NAME_AND_ACTIVE_ENDDATE = gql`
    query (
        $date: MultiTypeInput
        $propertyId: MultiTypeInput
        $orderBy: String = "name"
        $orderByDirection: GraphQLDirection = ASC
    ) {
        table(
            name: "campaign"
            join: [{ table: "campaign_property", fk: "campaign_id", joinFk: "sfid" }]
            columns: [
                "id"
                "name"
                "startdate"
                "enddate"
                "description"
                "isactive"
                "islocal"
                "sfid"
            ]
            filter: [
                { left: "isdeleted", right: "false", expression: "=" }
                { left: "isactive", right: "true", expression: "=" }
                { left: "name", right: "NULL", expression: "IS NOT" }
                { left: "name", right: "", expression: "<>" }
                { left: "enddate", right: "NULL", expression: "IS NOT" }
                { left: "enddate", right: "", expression: "<>" }
                { left: "enddate", right: $date, expression: ">" }
                {
                    table: "campaign_property"
                    left: "property_id"
                    right: $propertyId
                    expression: "="
                }
            ]
            limit: 2000
            orderBy: $orderBy
            orderByDirection: $orderByDirection
        )
    }
`;

export const CREATE_CAMPAIGN = gql`
    mutation (
        $name: MultiTypeInput
        $createddate: MultiTypeInput
        $startdate: MultiTypeInput
        $enddate: MultiTypeInput
        $sfid: MultiTypeInput
        $description: MultiTypeInput
        $isactive: MultiTypeInput
    ) {
        createRow(
            table: "campaign"
            values: [
                { property: "name", value: $name }
                { property: "sfid", value: $sfid }
                { property: "createddate", value: $createddate }
                { property: "systemmodstamp", value: $createddate }
                { property: "isdeleted", value: false }
                { property: "islocal", value: true }
                { property: "startdate", value: $startdate }
                { property: "enddate", value: $enddate }
                { property: "description", value: $description }
                { property: "isactive", value: $isactive }
            ]
        )
    }
`;

export const UPDATE_CAMPAIGN = gql`
    mutation (
        $id: String!
        $name: MultiTypeInput
        $startdate: MultiTypeInput
        $enddate: MultiTypeInput
        $date: MultiTypeInput
        $description: MultiTypeInput
        $isactive: MultiTypeInput
    ) {
        updateRow(
            table: "campaign"
            id: $id
            values: [
                { property: "name", value: $name }
                { property: "startdate", value: $startdate }
                { property: "enddate", value: $enddate }
                { property: "description", value: $description }
                { property: "isactive", value: $isactive }
                { property: "systemmodstamp", value: $date }
            ]
        )
    }
`;

export const DELETE_CAMPAIGN = gql`
    mutation ($id: String!) {
        deleteRow(table: "campaign", id: $id)
    }
`;
